import { Dropdown } from "../common";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

export default (props) => {
  const {
    proxy,
    lang,
    auth: user,
    profiles,
    pages,
    functions,
  } = useSelector((state) => state);
  let navigate = useNavigate();

  const { is_public } = props;
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const [defaultValue, setDefaultValue] = useState({});
  const fullname = localStorage.getItem("fullname");
  const stringifiedUser = localStorage.getItem("user");
  // const user = JSON.parse(stringifiedUser);
  // console.log(pages)
  const [isExpanded, setIsExpanded] = useState(true);
  const dispatch = useDispatch();
  const langs = [
    { id: 0, label: lang["vi"], flag: "vietnam.png", value: "Vi" },
    { id: 1, label: lang["en"], flag: "united-kingdom.png", value: "En" },
  ];
  const options = langs;
  // const url = window.location.pathname.slice(1);
  // const page_id = url.split("/")[0];

  // const [isThisPagePublic, setIsThisPagePublic] = useState(false);
  // const [isThisPageNotPublic, setIsThisPageNotPublic] = useState(false);

  useEffect(() => {
    let langItem = localStorage.getItem("lang");
    langItem = langItem ? langItem : "Vi";
    const defaultLang = langs.filter((l) => l.value == langItem)[0];
    setDefaultValue(defaultLang);
  }, []);

  const LanguageRender = ({ name, flag }) => {
    return (
      <div className="d-flex flex-nowrap">
        <img style={{ width: 22 }} src={`/images/flags/${flag}`} />
        {!isMobile && <span className={`d-block ml-2`}>{name}</span>}
      </div>
    );
  };
  const DropdownLanguageRender = ({ name, flag }) => {
    return (
      <div className="d-flex flex-nowrap">
        <img style={{ width: 22 }} src={`/images/flags/${flag}`} />
        <span className={`d-block ml-2`}>{name}</span>
      </div>
    );
  };

  const signOut = () => {
    window.location = "/signout";
  };
  const signIn = () => {
    window.location = "/login";
  };

  const clickHandler = (e, opt) => {
    e.preventDefault();
    setLanguage(opt);
  };

  const setLanguage = ({ value }) => {
    localStorage.setItem("lang", value);
    window.location.reload();
  };

  const generateUserLastName = () => {
    const { fullname } = user;
    const maxLength = 10;

    if (fullname) {
      const names = fullname.split(" ");
      let displayFullName = fullname;

      // Cắt chuỗi nếu vượt quá maxLength và thêm "..."
      if (displayFullName.length > maxLength) {
        displayFullName = displayFullName.substring(0, maxLength) + "...";
      }

      return displayFullName;
    } else {
      return "";
    }
  };

  const sidebarToggle = (e) => {
    e.preventDefault();
    $("#sidebar").toggleClass("active");
    setIsExpanded((prevState) => !prevState);
    dispatch({
      type: "setSidebar",
      payload: { sidebar: isExpanded },
    });
  };

  useEffect(() => {
    dispatch({
      type: "setSidebar",
      payload: { sidebar: isExpanded },
    });
  }, [isExpanded]);
  return is_public ? (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          top: 0,
          width: "100%",
          position: "fixed",
          backgroundColor: "#fff",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            padding: "5px 5px 5px 0",
            width: "70%",
          }}
        >
          <img
            src="/images/logo/logodpm.png"
            style={{
              height: "60px",
            }}
          />
        </div>
      </div>
    </>
  ) : (
    <div class="topbar" style={{ backgroundColor: "#274452" }}>
      <nav class="bg-cus navbar navbar-expand-lg navbar-light">
        <div
          class="full d-flex flex-row full-navbar full-navbar-custom"
          // style={{ backgroundColor: "#274452" }}
        >
          <button
            onClick={sidebarToggle}
            type="button"
            id="sidebarCollapse"
            class="sidebar_toggle"
          >
            <i class="fa fa-bars"></i>
          </button>
          <div className="ml-auto dropdown d-flex align-items-center">
            {/* <div
              className="d-flex flex-nowrap"
              id="lang-drop-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <a href="#" className="d-block text-light">
                {isMobile ? (
                  <LanguageRender flag={defaultValue.flag} />
                ) : (
                  <DropdownLanguageRender
                    name={defaultValue.label}
                    flag={defaultValue.flag}
                  />
                )}
              </a>

              <a className="d-block ml-2" href="#">
                <i class="fa fa-caret-down"></i>
              </a>
            </div> */}
            {/* <div className="dropdown-menu" aria-labelledby="#lang-drop-toggle">
              {options.map((opt) => (
                <a
                  key={opt.id}
                  href="#"
                  className="dropdown-item cursor-pointer"
                  onClick={(e) => {
                    clickHandler(e, opt);
                  }}
                >
                  <DropdownLanguageRender name={opt.label} flag={opt.flag} />
                </a>
              ))}
            </div> */}
          </div>
          <div class="d-flex flex-nowrap">
            <div class="icon_info">
              <ul>
                {/* <li><a href="#"><i class="fa fa-question-circle"></i></a></li>
                            <li><a href="#"><i class="fa fa-bell-o"></i><span class="badge">2</span></a></li> */}
                {/* <li><a href="#"><i class="fa fa-envelope-o"></i><span class="badge">1</span></a></li> */}
              </ul>
              <ul class="user_profile_dd" title={user.fullname}>
                <li>
                  <a class="dropdown-toggle" data-toggle="dropdown">
                    {/* <span class="name_user"> {generateUserLastName()}</span> */}
                    <span class="name_user">
                      {" "}
                      <img
                        class="img-responsive circle-image"
                        src={proxy() + user.avatar}
                        alt="#"
                        onError={(e) => {
                          if (
                            e.target.src !==
                            proxy() + "/image/avatar/default-ava.png"
                          ) {
                            e.target.src =
                              proxy() + "/image/avatar/default-ava.png";
                          }
                        }}
                      />{" "}
                      {user.fullname}
                    </span>
                  </a>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      onClick={() => navigate("/user/profile")}
                    >
                      {/* /users/profile */}
                      {lang["my profile"]}
                    </a>
                    {/* <a class="dropdown-item" href="settings.html">{lang["settings"]}</a> */}
                    {/* {user !== null && user.role !== "uad" && (
                      <a class="dropdown-item" href="/changepassword">
                        {lang["change password"]}
                      </a>
                    )} */}
                    <a class="dropdown-item" href="#" onClick={signOut}>
                      {lang["signout"]}
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};
